/**
 * fibre.js — the pace of the LIGHT IN THE FIBRE.
 *
 * A member's connector is a fibre: while that member has runs in flight a pulse
 * of light travels down it, parent → member (the way work flows), and the more
 * runs the faster. Founder (2026-08-26): "make it cool like fiber running if a
 * agent is running so seeing light travel through fiber effect … if multiple
 * agent running make it go faster".
 *
 *   period = max(FIBRE_PERIOD_MIN_S, FIBRE_PERIOD_BASE_S / runs)
 *   1 run → 2.4s · 2 → 1.2s · 3 → 0.8s · 4 → 0.6s · 5+ → 0.5s
 *
 * The floor is where "fast" would turn into strobing — and the eye has stopped
 * reading a count by then anyway (MemberNode caps its paper stack at 5 for the
 * same reason). The count is the SAME `activeRuns` the satellite's paper stack
 * is drawn from (memberSatellites stamps one number on the node and its edge),
 * never a second read.
 *
 * TWO PLACES, one contract — the self-host dashboard's twin is
 * `fibrePeriodSec` in selfhosted/ui/index.html, with the same constants.
 */
export const FIBRE_PERIOD_BASE_S = 2.4;
export const FIBRE_PERIOD_MIN_S = 0.5;

/** Seconds for one pulse to travel the connector for `runs` in flight; 0 when idle. */
export function fibrePeriodSec(runs) {
  const n = Number(runs) > 0 ? Math.floor(Number(runs)) : 0;
  if (!n) return 0;
  // To the millisecond — 2.4 / 3 is 0.7999…, which is not a CSS value anyone
  // should read in devtools.
  return Math.round(Math.max(FIBRE_PERIOD_MIN_S, FIBRE_PERIOD_BASE_S / n) * 1000) / 1000;
}

/** The period as the CSS value the stylesheet reads ("0.8s"); "" when idle. */
export function fibrePeriodCss(runs) {
  const p = fibrePeriodSec(runs);
  return p ? `${p}s` : '';
}
